export function postMessage(message) {
  if (window.parent) {
    window.parent.postMessage({
      ...message,
      iframeName: 'cashier-payments-widget',
    }, '*');
  }
}



// WEBPACK FOOTER //
// ./utils/communicationUtils.ts